import styled from "styled-components";
import TextGothic from "components/utils/TextGothic";
import { PlacelistType } from "resources/placelists";
import PlacelistItem from "components/PlacelistItem";
import { media } from "utils/media";

type Props = {
  otherPlacelists: PlacelistType[];
};

const Index = (props: Props) => {
  const { otherPlacelists } = props;

  return (
    <Wrapper>
      <Center size="20px">その他のプレイスリスト</Center>
      <PlacelistWrapper>
        {otherPlacelists.map((placelist, i) => (
          <PlacelistItem
            key={`placelist_${i}`}
            placelist={placelist}
            index={i}
          />
        ))}
      </PlacelistWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background: #eee;
  ${media.sp`
    padding: 48px 0;
  `}
  ${media.pc`
    padding: 80px 0;
  `}
`;

const Center = styled(TextGothic)`
  text-align: center;
`;

const PlacelistWrapper = styled.div`
  ${media.pc`
   padding-top: 80px;
  `}
`;

export default Index;
